import React, { useEffect, useState } from 'react';
import { apiHandler } from '../../api/apihandler';
import { AD_LIST, AD_VIEW, AD_CLICK } from '../../api/constants';

// Compact sponsored slot at the bottom of the left nav ("Left" ad position,
// position=3 in the ad-creation flow). Reuses the nav's own `.nvn-seats-card`
// styling so it fits the narrow sidebar and hides itself in mini/collapsed
// mode along with the other nav promo card.
const LeftSideAdsCard = () => {
  const [ad, setAd] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await apiHandler(AD_LIST, 'POST', { page: 1, limit: 1, position: '3' });
        if (cancelled) return;
        const listData = res?.data?.data?.userPosts;
        const item = listData?.data?.[0];
        if (listData?.meta?.total > 0 && item) {
          setAd(item);
          apiHandler(AD_VIEW, 'POST', { ad_id: item.id, device_type: 0 }).catch(() => {});
        }
      } catch (e) { console.error(e); }
    })();
    return () => { cancelled = true; };
  }, []);

  if (!ad) return null;

  const trackClick = () => {
    apiHandler(AD_CLICK, 'POST', { ad_id: ad.id, device_type: 0 }).catch(() => {});
  };

  return (
    <a
      href={ad?.user_post_ad?.ad_link}
      target="_blank"
      rel="noopener noreferrer"
      onClick={trackClick}
      className="nvn-seats-card"
    >
      <p className="nvn-seats-label">Sponsored</p>
      <p className="nvn-seats-title">{ad?.user_post_ad?.title}</p>
      <span>{ad?.user_post_ad?.button_text || 'Learn more'}</span>
    </a>
  );
};

export default LeftSideAdsCard;
